/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Create_Choose_TypeInputs */

const en_clients_create_choose_type = /** @type {(inputs: Clients_Create_Choose_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What type of client?`)
};

const pt_br2_clients_create_choose_type = /** @type {(inputs: Clients_Create_Choose_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual tipo de cliente?`)
};

/**
* | output |
* | --- |
* | "What type of client?" |
*
* @param {Clients_Create_Choose_TypeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_create_choose_type = /** @type {((inputs?: Clients_Create_Choose_TypeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Create_Choose_TypeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_create_choose_type(inputs)
	return pt_br2_clients_create_choose_type(inputs)
});